/**
 * DEV-2916 — takip ana kartındaki İlam Bilgileri özet alanının veri şekli.
 *
 * Alacaklar ekranının da beslendiği `alacaklar` kayıtlarından türetilir
 * (bkz. `@/utils/ilamBilgisi`). Alanların hepsi opsiyoneldir: ilam tipine göre
 * farklı kolonlar dolar (mahkeme ilamında esas/karar no, noter senedinde
 * yevmiye no gibi). Hiçbiri dolu değilse kayıt listeye hiç alınmaz.
 */
export class IlamBilgisiEntity {
    alacak_id!: number;
    alacak_belge_turu: string | null = null;
    ilam_tipi: string | null = null;
    /** İlamı veren makam: mahkeme adı, noter adı ya da serbest metin kurum adı. */
    ilami_veren: string | null = null;
    /**
     * dosya_turleri.isim — "Hukuk Dava Dosyası", "Ceza Dava Dosyası" vb.
     * Kartta "İlam Türü" etiketiyle gösterilir; Alacaklar formundaki
     * "Dosya Türü" alanının aynısıdır.
     */
    dosya_turu: string | null = null;
    esas_no: string | null = null;
    karar_no: string | null = null;
    karar_tarihi: string | null = null;
    yevmiye_no: string | null = null;
}
